import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Questions'] });

const apiQuestionsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getQuestions: builder.query({
      query: ({ ean, mine }) => ({
        url: `/community/products/${ean}/questions/`,
        params: {
          mine,
        },
      }),
      providesTags: ['Questions'],
    }),
    addNewQuestion: builder.mutation({
      query: ({ payload, ean }) => ({
        url: `/community/products/${ean}/questions/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Questions'],
    }),
    updateQuestion: builder.mutation({
      query: ({ payload, ean, id }) => ({
        url: `/community/products/${ean}/questions/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Questions'],
    }),
    deleteQuestion: builder.mutation({
      query: ({ ean, id }) => ({
        url: `/community/products/${ean}/questions/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Questions'],
    }),
  }),
});

export const { useGetQuestionsQuery, useAddNewQuestionMutation, useUpdateQuestionMutation, useDeleteQuestionMutation } = apiQuestionsSlice;

export default apiQuestionsSlice;
